let menus = [

    {
        name: "首页",
        icon: "",
        url: "/home",
    },

    {
        name: "组件概览",
        icon: "icon ion-md-eye",
        url: "/comp-preview",
    },

    {
        name: "DEMO页面",
        icon: "icon ion-md-filing",
        url: "#",
        children: [
            {
                name: "列表页",
                icon: "",
                url: "/list-body-demo",
                children:[
                    {
                        name: "详情页",
                        icon: "icon ion-md-eye",
                        url: "/detail",
                    }
                ]
            },
            {
                name: "表单页",
                icon: "",
                url: "/form-body-demo"
            }
        ]
    }

];


export  default  menus;